import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/(public)/blog/sections/Hero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/(public)/blog/sections/NewsArticles.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/(public)/blog/sections/Subscribe.tsx");
